import { customApiCall } from "utils/axios";

type ConfigRecordRef = {
  projectId: string;
  recordId: string;
  scenario?: string;
};

type ConfigSaveArgs<TData> = ConfigWriteArgs<TData> & {
  isExisting: boolean;
};

type ConfigWriteArgs<TData> = ConfigRecordRef & {
  data: TData;
};

export const createConfigCrud = <TData>(
  resolveDetailUrl: (projectId: string, recordId: string, scenario?: string) => string
) => {
  const create = ({ data, projectId, recordId, scenario }: ConfigWriteArgs<TData>) =>
    customApiCall.post({ data, url: resolveDetailUrl(projectId, recordId, scenario) });

  const patch = ({ data, projectId, recordId, scenario }: ConfigWriteArgs<TData>) =>
    customApiCall.patch({ data, url: resolveDetailUrl(projectId, recordId, scenario) });

  const remove = ({ projectId, recordId, scenario }: ConfigRecordRef) =>
    customApiCall.delete({ url: resolveDetailUrl(projectId, recordId, scenario) });

  const save = ({ data, isExisting, projectId, recordId, scenario }: ConfigSaveArgs<TData>) =>
    isExisting ? patch({ data, projectId, recordId, scenario }) : create({ data, projectId, recordId, scenario });

  return { create, patch, remove, save };
};
